<template>
  <div>
    <div id="basic">
      <div class="row">
        <div class="col-md-6">
          <h2>Basic Validation</h2>
        </div>
        <div class="col-md-6 text-right">
          <button
            id="basicValidation"
            class="btn btn-primary btn-lg"
            :disabled="loadingStatus"
            @click="loadValidation()"
          >
            Run Again
          </button>
        </div>
      </div>
      <div
        v-if="loadingStatus"
        class="row"
      >
        <div class="col-sm-12">
          <empty-state
            icon="tasks"
            description="Basic Validation test is in progress"
          />
        </div>
      </div>
      <div v-if="!loadingStatus">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.images.issues"
              :title="imageLength"
              description="Images"
              :icon="imageIcon"
              :icon-color="imageColor"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.links.issues"
              :title="linkLength"
              description="Links"
              :icon="linksIcon"
              :icon-color="linksColor"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.unwantedHtmlTags.issues"
              :title="unwantedHtmlTagsLength"
              description="Unwanted HTML Tags"
              :icon="unwantedHtmlTagsIcon"
              :icon-color="unwantedHtmlTagsColor"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.spamCheck.issues"
              :title="info.translatedSpamCheck.total"
              description="Spam Assassin Score"
              :icon="spamCheckIcon"
              :icon-color="spamCheckColor"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <Card
              icon="image"
              title="Images"
              toggle
            >
              <ul class="links">
                <li
                  v-for="(img, index) in info.images.info"
                  :key="'image-info-' + index"
                >
                  <ejs-tooltip
                    :id="`info${index}`"
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="img"
                    status="Valid"
                    tip-pointer-position="Middle"
                    type="image"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="success"
                    />
                    <a
                      :id="`infoValid${index}`"
                      href="javascript:void(0)"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                    >{{ img }}</a>
                  </ejs-tooltip>
                </li>
                <li
                  v-for="(img, index) in info.images.issues"
                  :key="'image-issues-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="img"
                    status="Not Found"
                    tip-pointer-position="Middle"
                    type="image"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="danger"
                    />
                    <a
                      :id="`infoNotFound${index}`"
                      href="javascript:void(0)"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                    >{{ img | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
              </ul>
            </Card>
            <Card
              icon="link"
              title="Links"
              toggle
            >
              <ul class="links">
                <li
                  v-for="(link, index) in info.links.info"
                  :key="'link-info-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="link"
                    status="Valid"
                    tip-pointer-position="Middle"
                    type="link"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="success"
                    />
                    <a
                      :id="`linkValid${index}`"
                      :href="link|cleanURL"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                      target="_blank"
                    >{{ link | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
                <li
                  v-for="(link, index) in info.links.issues"
                  :key="'link-issues-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="link"
                    status="Not Accessible"
                    tip-pointer-position="Middle"
                    type="link"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="warning"
                    />
                    <a
                      :id="`linkNotAccessible${index}`"
                      :href="link|cleanURL"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                      target="_blank"
                    >{{ link | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
                <li
                  v-for="(link, index) in info.links.errors"
                  :key="'link-errors-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="link"
                    status="Error"
                    tip-pointer-position="Middle"
                    type="link"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="danger"
                    />
                    <a
                      :id="`linkError${index}`"
                      :href="link|cleanURL"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                      target="_blank"
                    >{{ link | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
              </ul>
            </Card>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <Card
              icon="ban"
              title="Spam Assassin"
            >
              <table class="table-list table-list-lines spam-assassin-table">
                <tr>
                  <td class="table-list--title">
                    Administrator
                  </td>
                </tr>
                <tr
                  v-for="(admin,index) in info.translatedSpamCheck.administrator"
                  :key="'admin-' + index"
                  class="border-bottom"
                >
                  <td class="table-list--subtitle">
                    {{ admin.description }}
                  </td>
                  <td>{{ admin.point }}</td>
                </tr>
                <tr>
                  <td class="table-list--title">
                    Body
                  </td>
                </tr>
                <tr
                  v-for="(admin,index) in info.translatedSpamCheck.body"
                  :key="'body-' + index"
                  class="border-bottom"
                >
                  <td class="table-list--subtitle">
                    {{ admin.description }}
                  </td>
                  <td>{{ admin.point }}</td>
                </tr>
                <tr>
                  <td class="table-list--title">
                    Informational
                  </td>
                </tr>
                <tr
                  v-for="(admin,index) in info.translatedSpamCheck.informational"
                  :key="'informational-' + index"
                  class="border-bottom"
                >
                  <td class="table-list--subtitle">
                    {{ admin.description }}
                  </td>
                  <td>{{ admin.point }}</td>
                </tr>
                <tr>
                  <td class="table-list--title">
                    <strong>Total</strong>
                  </td>
                  <td :class="{'text-success': info.translatedSpamCheck.total < 5}">
                    {{ info.translatedSpamCheck.total }}
                  </td>
                </tr>
              </table>
            </Card>
          </div>
          <div class="col-sm-6">
            <Card
              icon="code"
              title="Unwanted HTML Tags"
            >
              <p v-if="info.microsoftWordTags.issues && !info.unwantedHtmlTags.issues.length">
                No tags found
              </p>
              <ul v-if="info.microsoftWordTags.issues && info.unwantedHtmlTags.issues.length">
                <li
                  v-for="(tag, index) in info.unwantedHtmlTags.issues"
                  :key="'html' + index"
                >
                  {{ tag }}
                </li>
              </ul>
            </Card>
            <Card
              icon="file"
              title="Microsoft Word Tags"
            >
              <p v-if="info.microsoftWordTags.issues && !info.microsoftWordTags.issues.length">
                No tags found
              </p>
              <ul v-if="info.microsoftWordTags.issues && info.microsoftWordTags.issues.length">
                <li
                  v-for="(tag, index) in info.microsoftWordTags.issues"
                  :key="'word' + index"
                >
                  {{ tag }}
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import InfoCard from '@/components/InfoCard'
import Card from '@/components/Card'
import EmptyState from '@/components/EmptyState'
import { iframeParentCommunication } from '@/mixins/iframeParentCommunication'

const tooltipTemplate = Vue.component('TooltipTemplate', {
  data () {
    return {
      data: '',
      color: '',
      status: '',
      type: ''
    }
  },
  mounted () {
    this.data = this.$parent.$attrs.link
    this.status = this.$parent.$attrs.status
    if (this.status.toUpperCase() === 'VALID' || this.status.toUpperCase() === 'INFO') {
      this.color = 'success'
    } else if (this.status === 'Not Found' || this.status === 'Error') {
      this.color = 'danger'
    } else {
      this.color = 'warning'
    }
    this.type = this.$parent.$attrs.type
  },
  methods: {
  },
  template: `<div>
              <p class="testing-img" v-if='this.status === "Valid" && this.type ==="image"'><img :src="data"></p>
              <p><svg data-v-57ab6f42="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-circle fa-w-16 fa-xs" :class='color'><path data-v-57ab6f42="" fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg> {{status}}</p>
              <a :href="data" target="_blank">{{data | cleanURL}}</a>
            </div>`
})

export default {
  name: 'TemplateDetailsTesting',
  components: {
    InfoCard,
    Card,
    EmptyState
  },
  mixins: [iframeParentCommunication],
  data () {
    return {
      tab: 'basic',
      cssClass: 'testing-tooltip',
      info: {
        images: {},
        links: {},
        unwantedHtmlTags: {},
        microsoftWordTags: {},
        spamCheck: {},
        translatedSpamCheck: {}
      },
      tooltipTemplate () {
        return {
          template: tooltipTemplate
        }
      },
      toastPosition: { X: 'Right', Y: 'Top' }
    }
  },
  computed: {
    ...mapGetters({
      validation: 'getTemplateBasicValidation',
      loadingStatus: 'getLoadingStatus',
      validationByType: 'getTemplateValidationByType',
      getTemplate: 'getTemplateSummary',
      validationTemplateId: 'getValidationTemplateId',
      activeType: 'getActiveType'
    }),
    ...mapState({
      accountId: state => state.templateBuilder.accountId
    }),
    imageLength () {
      return this.info.images.issues.length + this.info.images.info.length + this.info.images.errors.length
    },
    linkLength () {
      return this.info.links.info.length + this.info.links.issues.length + this.info.links.errors.length
    },
    unwantedHtmlTagsLength () {
      return this.info.unwantedHtmlTags.info.length + this.info.unwantedHtmlTags.issues.length + this.info.unwantedHtmlTags.errors.length
    },
    microsoftWordTagsLength () {
      return this.info.microsoftWordTags.info.length + this.info.microsoftWordTags.issues.length + this.info.microsoftWordTags.errors.length
    },
    spamCheckLength () {
      return this.info.spamCheck.info.length + this.info.spamCheck.issues.length + this.info.spamCheck.errors.length
    },
    imageIcon () {
      return this.info.images.issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    imageColor () {
      return this.info.images.issues.length > 0 ? 'danger' : 'success'
    },
    linksIcon () {
      return this.info.links.errors.length > 0 || this.info.links.issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    linksColor () {
      if (this.info.links.errors.length > 0) {
        return 'danger'
      } else if (this.info.links.issues.length > 0) {
        return 'warning'
      } else {
        return 'success'
      }
    },
    unwantedHtmlTagsIcon () {
      return this.info.unwantedHtmlTags.errors.length > 0 || this.info.unwantedHtmlTags.issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    unwantedHtmlTagsColor () {
      return this.info.unwantedHtmlTags.errors.length > 0 || this.info.unwantedHtmlTags.issues.length > 0 ? 'danger' : 'success'
    },
    microsoftWordTagsIcon () {
      return this.info.microsoftWordTags.errors.length > 0 || this.info.microsoftWordTags.issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    spamCheckIcon () {
      return this.info.spamCheck.errors.length > 0 || this.info.spamCheck.issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    microsoftWordTagsColor () {
      return this.info.microsoftWordTags.errors.length > 0 || this.info.microsoftWordTags.issues.length > 0 ? 'danger' : 'success'
    },
    spamCheckColor () {
      return this.info.spamCheck.errors.length > 0 || this.info.spamCheck.issues.length > 0 ? 'danger' : 'success'
    }
  },
  watch: {
    validation (val) {
      this.renderValidation()
    },
    accountId (newV, oldV) {
      if (newV !== oldV) {
        this.init()
      }
    }
  },
  mounted () {
    if (this.accountId) {
      this.init()
    }
  },
  methods: {
    init () {
      if ((this.$route.query.templateId && this.validation.length === 0) || this.validationTemplateId !== this.$route.query.templateId) {
        if (this.activeType === 'saved') {
          this.$store.dispatch('setTemplateBasicValidation', { templateId: this.$route.query.templateId })
        } else if (this.activeType === 'prebuilt') {
          this.$store.dispatch('setPrebuiltTemplateBasicValidation', { templateId: this.$route.query.templateId })
        }
      } else {
        this.renderValidation()
      }
    },
    renderValidation () {
      this.info.images = this.validationFilter('ImagesExistTest')[0]
      this.info.links = this.validationFilter('LinksValidTest')[0]
      this.info.unwantedHtmlTags = this.validationFilter('BadHtmlTagsTest')[0]
      this.info.microsoftWordTags = this.validationFilter('MsWordHtmlTest')[0]
      this.info.spamCheck = this.validationFilter('PostmarkSpamTest')[0]
      this.filterSpamAssassin()
    },
    validationFilter (value) {
      return this.validationByType(value)
    },
    loadValidation () {
      if (this.$route.query.templateId) {
        if (this.activeType === 'saved') {
          this.$store.dispatch('setTemplateBasicValidation', { templateId: this.$route.query.templateId })
        } else if (this.activeType === 'prebuilt') {
          this.$store.dispatch('setPrebuiltTemplateBasicValidation', { templateId: this.$route.query.templateId })
        }
      }
    },
    filterSpamAssassin () {
      const data = this.info.spamCheck
      const spamCheck = { body: [], informational: [], administrator: [], total: '' }
      if (data.info[0]) {
        let total = data.info[0].substring(data.info[0].lastIndexOf(' ') + 1)
        total = total.replace(/.\s*$/, '')
        spamCheck.total = total
        for (let i = 0; i < data.issues.length; i++) {
          const str = data.issues[i]
          const type = str.match(/points:\s(\w*)/, ' ')
          if (type[1] === 'BODY') {
            const result = str.substring(str.lastIndexOf(': ') + 1)
            const point = str.substring(0, str.indexOf(' points:'))
            spamCheck.body.push({ description: result, point: point })
          } else if (type[1].toUpperCase() === 'INFORMATIONAL') {
            const result = str.substring(str.lastIndexOf(': ') + 1)
            const point = str.substring(0, str.indexOf(' points:'))
            spamCheck.informational.push({ description: result, point: point })
          } else {
            const result = str.substring(str.lastIndexOf(': ') + 1)
            const point = str.substring(0, str.indexOf(' points:'))
            spamCheck.administrator.push({ description: result, point: point })
          }
        }
      }
      this.info.translatedSpamCheck = spamCheck
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-tabs {
  border-bottom: none;
}
.nav-item {
  margin-bottom: 20px;
  .divider {
    margin: 0 8px;
  }
  a {
    color: $blue-dark;
    text-decoration: none;
    &:hover {
      cursor: pointer;
    }
    &.active {
      text-decoration: underline;
    }
  }
}
.links li {
  padding: 14px 0;
  a {
    margin-left: 6px;
    font-size: 1.4rem;
  }
}
a {
  text-decoration: none;
}
.btn-lg {
  font-size: 1.5rem !important;
}
.template-empty-state {
  text-align: center;
  svg {
    color: $secondary-light;
  }
}
#basicValidation {
  margin-bottom: 20px;
}
table.spam-assassin-table {
  tr td:first-child {
    width: 75%;
  }
}
.empty-state {
  .empty-state-icon {
    font-size: 6.4rem;
  }
  h4 {
    font-size: 1.8rem;
  }
  .empty-state-text {
    font-size: 1.6rem;
    margin-bottom: 20px;
    text-align: center;
  }
}

</style>
